// extracted by mini-css-extract-plugin
export default {"main":"Home_main__C6oBA","div":"Home_div__pvbrz"};